import { StatusBadge } from '@/components/ui/StatusBadge'
import type { BadgeTone } from '@/components/ui/Badge'
import type { PoStatus } from '@/services/procurement'
import type { StockStatus } from '@/services/inventory'

const poTone: Record<PoStatus, BadgeTone> = {
  DRAFT: 'neutral',
  PENDING_APPROVAL: 'warning',
  APPROVED: 'info',
  SENT: 'info',
  PARTIAL: 'warning',
  RECEIVED: 'success',
  CANCELLED: 'danger',
  SHORT: 'danger',
}

const stockTone: Record<StockStatus, BadgeTone> = {
  AVAILABLE: 'success',
  QUARANTINE: 'warning',
  BLOCKED: 'danger',
  DAMAGED: 'danger',
  REWORK: 'warning',
}

export function PoStatusBadge({ status }: { status: PoStatus }) {
  return (
    <StatusBadge
      tone={poTone[status]}
      label={status.replaceAll('_', ' ')}
      showDot={false}
    />
  )
}

export function StockStatusBadge({ status }: { status: StockStatus }) {
  return <StatusBadge tone={stockTone[status]} label={status} showDot={false} />
}

export function InvStatusBadge({
  available,
  min = 0,
  safety = 0,
  outOfStock,
  belowThreshold,
}: {
  available?: number
  min?: number
  safety?: number
  outOfStock?: boolean
  belowThreshold?: boolean
}) {
  const isOutOfStock = outOfStock !== undefined ? outOfStock : (available !== undefined && available <= 0)
  if (isOutOfStock) return <StatusBadge tone="danger" label="Hết hàng" />

  const threshold = Math.max(min, safety)
  const isBelowThreshold = belowThreshold !== undefined
    ? belowThreshold
    : (available !== undefined && threshold > 0 && available < threshold)

  if (isBelowThreshold) return <StatusBadge tone="warning" label="Dưới ngưỡng" />
  return <StatusBadge tone="success" label="Ổn định" />
}

const suggestionTone: Record<'OPEN' | 'CONVERTED' | 'DISMISSED', BadgeTone> = {
  OPEN: 'warning',
  CONVERTED: 'success',
  DISMISSED: 'neutral',
}

export function SuggestionStatusBadge({
  status,
}: {
  status: 'OPEN' | 'CONVERTED' | 'DISMISSED'
}) {
  return (
    <StatusBadge tone={suggestionTone[status]} label={status} showDot={false} />
  )
}
